import { FaStar } from 'react-icons/fa';
export const COLUMNS = [
    {
        Header: "Name",
        id: "player_name", // For styling
        accessor: row => `${row.first_name} ${row.last_name}`
    },
    {
        Header: "Rating",
        accessor: "stars",
        Cell: ({ value }) => {
            if (value === "-") {
                value = 0;
            }
            return (
                <div style={{display:"flex",justifyContent:"center"}}>
                    {[...Array(5)].map((_, i) => ( 
                        <FaStar 
                            key={i} 
                            style={{gap:"3px",fontSize: "14px" }} 
                            color={i < value ? "#ff3d00" : "#ddd"} 
                        /> 
                    ))}
                </div>
            );
        }
    },
    {
        Header: "Position",
        accessor: "position_name"
    },
    {
        Header: "Grad Year",
        accessor: "grad_year"
    },
    {
        Header: "State",
        accessor: "state"
    },
    {
        Header: "GPA",
        accessor: "gpa"
    },
    {
        Header: "Next Game",
        accessor: "next_game",
        Cell: ({ value }) => {
            if (!value) return "-";
            const date = new Date(value);

            // format time to a readable format
            return date.toLocaleDateString("en-US", { 
                month: "short", 
                day: "numeric",
                hour: "numeric",
                minute: "2-digit"
            });
        }
    },
    {
        Header: "Last Updated",
        accessor: "last_updated",
        Cell: ({ value }) => {
            if(!value) return "-";
            const date = new Date(value);

            // format time to a readable format 
            return date.toLocaleDateString("en-US", { 
                month: "short", 
                day: "numeric",
                hour: "numeric",
                minute: "2-digit"
            });
        }
    }
    
]
